var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDodamTextLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uB808\\uC774\\uC5B4_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 87.6 21.9",
    style: {
      enableBackground: "new 0 0 87.6 21.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#0067BC;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0.1,18c1.9,0,5.1,0,8.4,0c0-1.6,0-3.4,0.1-4.2c0.7-0.1,2.8-0.1,3.7,0c0,1,0,2.7,0,4.2c3.9,0,7.4,0,8.5,0 c0.1,0.9,0.1,2.1,0,3.1c-2.1,0.1-17.8,0.1-20.6,0C0,20.2,0,18.9,0.1,18z M1.4,1c2.3-0.1,15.4-0.1,17.8,0c0.1,0.9,0.1,2.4,0,3.3 c-1.7,0-12.3,0-14.1,0c0,1.1,0,3.9,0,4.9c1.9,0,12.8,0,14.5,0c0.1,0.9,0.1,2.5,0,3.2c-2,0.1-15.9,0.1-18.3,0C1.2,9.6,1.3,3.7,1.4,1 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22.6,0.5c2.3-0.1,9.6-0.1,12,0c0.1,0.9,0.1,2.1,0,3c-1.7,0-6.6,0-8.4,0c0,1.1,0,2.8,0,3.8c1.9,0,7.6,0,9.4,0 c0.1,0.9,0.1,2.3,0,3c-2,0.1-10.9,0.1-13,0C22.4,7.6,22.4,3.3,22.6,0.5z M23.4,12.5c1.5-0.1,17.2-0.1,17.8,0c0.1,1.9,0.1,7.5,0,9.3 c-1.6,0.1-16,0.2-17.8,0C23.3,19.1,23.3,14.9,23.4,12.5z M37.7,18.8c0-0.7,0-2.4,0-3.2c-1.3-0.1-9.2,0-10.8,0c0,0.7-0.1,2.3,0,3.2 C28,18.8,36.7,18.8,37.7,18.8z M37.7,0.1c0.7-0.1,2.7-0.1,3.6,0c0,0.9,0,2.2,0,3.6c0.9,0,1.6,0,2.1,0c0.1,0.9,0.1,2.3,0,3.2 c-0.4,0-1.1,0.1-2.1,0.1c0,1.8,0,3.4,0,4.3c-0.7,0.1-2.7,0.1-3.6,0C37.6,9.4,37.6,1.9,37.7,0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M44.2,18c1.9,0,5.1,0,8.5,0c0-1.6,0-3.4,0-4.2c0.7-0.1,2.8-0.1,3.7,0c0,1,0,2.7,0,4.2c3.9,0,7.4,0,8.5,0 c0.1,0.9,0.1,2.1,0,3.1c-2.1,0.1-17.8,0.1-20.6,0C44.1,20.2,44.1,18.9,44.2,18z M45.5,1c2.3-0.1,15.4-0.1,17.8,0 c0.1,0.9,0.1,2.4,0,3.3c-1.7,0-12.3,0-14.1,0c0,1.1,0,3.9,0,4.9c1.9,0,12.8,0,14.5,0c0.1,0.9,0.1,2.5,0,3.2c-2,0.1-15.9,0.1-18.3,0 C45.4,9.6,45.4,3.7,45.5,1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M66.7,0.5c2.3-0.1,9.6-0.1,12,0c0.1,0.9,0.1,2.1,0,3c-1.7,0-6.6,0-8.4,0c0,1.1,0,2.8,0,3.8c1.9,0,7.6,0,9.4,0 c0.1,0.9,0.1,2.3,0,3c-2,0.1-10.8,0.1-13,0C66.6,7.6,66.6,3.3,66.7,0.5z M67.6,12.5c1.5-0.1,17.2-0.1,17.8,0c0.1,1.9,0.1,7.5,0,9.3 c-1.6,0.1-16,0.2-17.8,0C67.4,19.1,67.5,14.9,67.6,12.5z M81.9,18.8c0.1-0.7,0.1-2.4,0-3.2c-1.3-0.1-9.2,0-10.8,0 c-0.1,0.7-0.1,2.3,0,3.2C72.2,18.8,80.9,18.8,81.9,18.8z M81.8,0.1c0.7-0.1,2.7-0.1,3.6,0c0,0.9,0,2.2,0,3.6c0.9,0,1.6,0,2.1,0 c0.1,0.9,0.1,2.3,0,3.2c-0.4,0-1.1,0.1-2.1,0.1c0,1.8,0,3.4-0.1,4.3c-0.7,0.1-2.7,0.1-3.6,0C81.7,9.4,81.7,1.9,81.8,0.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDodamTextLogo);
export default __webpack_public_path__ + "static/media/dodam_text_logo.a41fcdb3324cf4ece11cf53ad842fbe8.svg";
export { ForwardRef as ReactComponent };